// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'cancel';

export const Component = () => (
  <path d='M20.93 3.592C18.535 1.198 15.662 0 12.26 0c-3.4 0-6.273 1.198-8.668 3.592C1.198 5.987 0 8.86 0 12.261c0 3.4 1.198 6.274 3.592 8.669 2.395 2.394 5.268 3.592 8.669 3.592 3.4 0 6.274-1.198 8.669-3.592 2.394-2.395 3.592-5.268 3.592-8.67 0-3.4-1.198-6.273-3.592-8.668Zm-8.668 19.924c-3.114 0-5.796-1.102-7.999-3.305C2.06 18.008.96 15.373.96 12.26c0-2.921 1.005-5.46 3.017-7.615l15.9 15.9c-2.156 1.963-4.694 2.97-7.615 2.97Zm8.285-3.64-15.9-15.9C6.802 1.964 9.34.959 12.262.959c3.113 0 5.795 1.101 7.998 3.304 2.203 2.251 3.305 4.885 3.305 7.999 0 2.92-1.006 5.46-3.017 7.615l-.001-.001Z' />
);

export const viewBox = '0 0 25 25';
